import React from 'react';
import styled from 'styled-components';
import {ImageType} from '../../../types/Image';
import {UnstyledLink} from '../../atoms/UnstyledLink/UnstyledLink';
import {ProfileCard} from '../../molecules/ProfileCard/ProfileCard';
import {TeaserImage, TeaserImageProps} from './TeaserImage';

interface ProfileTileProps {
  className?: string;
  testId: string;
  profile: {
    to?: string;
    headline: string;
    subline?: string;
    image?: ImageType;
    followButton: React.ReactNode | null;
  } | null;
  teaser: {
    to: string;
    image: ImageType;
    onClick?: (ev: React.MouseEvent) => void;
    content: TeaserImageProps['content'];
  };
  profileCardPosition: 'bottom' | 'top';
}

export const ProfileTile = ({
  testId,
  profile,
  teaser: {to: teaserPath, image: teaserImage, content},
  className,
  profileCardPosition,
  ref,
}: React.PropsWithChildren<ProfileTileProps> & {
  ref?: React.Ref<HTMLElement>;
}) => {
  return (
    <ProfileTileWrapper
      ref={ref}
      data-testid={testId || `profileTile`}
      className={className}
      to={teaserPath}
      as={teaserPath ? UnstyledLink : 'section'}
      $profileCardPosition={profileCardPosition}
    >
      {profile && <ProfileCard {...profile} />}
      <TeaserImage image={teaserImage} content={content} />
    </ProfileTileWrapper>
  );
};

const ProfileTileWrapper = styled.section<{
  $profileCardPosition: 'bottom' | 'top';
  to?: string;
}>`
  position: relative;
  display: flex;
  flex-direction: ${({$profileCardPosition}) =>
    $profileCardPosition === 'bottom' ? 'column-reverse' : 'column'};
`;
